import React, { Component } from 'react'
import axios from 'axios'
import cfg from '../../../../utils/config'
import auth from '../../../../utils/auth'
import moment from 'moment'
import { Badge } from 'reactstrap'
import { Link } from 'react-router-dom'
import ModalAlerta from '../../../../components/ModalAlerta'
import Table from '../../../../components/Table'

class ListaAlertas extends Component {
    state = {
        params: {
            descricao: "",
            params: {}
        },
        alertas: [],
        loading: false,
        selected: null,
        lastKey: null,
        end: false,
        limit_table: 10,
        alertasIntervalFn: false,
        count: 0,
        count_novo: 0,
        count_pendente: 0,
        count_finalizados: 0,
    }

    componentDidMount = () => {
        if (this.props.dataWidget) {
            const limitFromParams = this.props.dataWidget.params?.limit || 10
            
            this.setState({ 
                params: this.props.dataWidget,
                limit_table: limitFromParams
            }, () => {
                this.getAlertas()
                this.startAlertasInterval()
            })
        } else {
            this.getAlertas()
        }
    }

    componentWillUnmount = () => {
        clearInterval(this.state.alertasIntervalFn)
    }

    componentWillReceiveProps = (nextProps) => {
        const currentParams = this.props.dataWidget?.params
        const nextParams = nextProps.dataWidget?.params
        
        const paramsChanged = JSON.stringify(currentParams) !== JSON.stringify(nextParams)
        
        if (paramsChanged) {
            const limitFromParams = nextProps.dataWidget.params?.limit || 10
            
            this.setState({ 
                params: nextProps.dataWidget,
                limit_table: limitFromParams
            }, () => {
                this.restartAlertasInterval()
                this.getAlertas({ clear: true })
            })
        }
    }

    getAlertas = ({ clear = false } = {}) => {
        let config_me = {}
        let userInfo = {}
        let url = ""
        let { lastKey, limit_table } = this.state

        if (this.props.shared) {
            url = cfg.base_api_url + cfg.api_v2 + `/${this.props.hash}/alerta-historico-supervisorio/?limit=${limit_table}&secret_link=${this.props.hash}`
            config_me = null
        } else {
            config_me = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }
            userInfo = auth.getUserInfo()
            url = cfg.base_api_url + cfg.api_v2 + `/${userInfo.empresa}/alerta-historico-supervisorio/?limit=${limit_table}`
        }


        this.setState({ loading: true })

        let bodyForm = new FormData()

        if (clear) {
            bodyForm.set("last_key", null)
            this.setState({ alertas: [], loading: true })
        } else {
            bodyForm.set("last_key", Boolean(lastKey) ? JSON.stringify(lastKey) : null)
        }

        axios({ url, method: "POST", data: bodyForm, ...config_me }).then((res) => {
            let { limit, count, count_novo, count_pendente, count_finalizados, lastKey, data } = res.data
            let alertas = []
            let end = false

            alertas = clear ? data : [...this.state.alertas, ...data]

            this.setState({ alertas, lastKey, end: data.length < limit_table, loading: false, count, count_novo, count_pendente, count_finalizados })
        }).catch(err => {
            this.setState({ loading: false })
        })
    }

    carregarMais = () => {
        this.getAlertas({ clear: false })
    }

    getColumns = () => {
        return [{
            Header: 'Descrição',
            Accessor: 'descricao',
            sortable: false,
            Cell: (original) => {
                return (
                    <div
                        style={{ cursor: "pointer", color: "#007bff", fontSize: "13px" }}
                        onClick={() => this.setState({ selected: original })}>
                        {original?.descricao}
                    </div>
                )
            }
        }, {
            Header: auth.getUserInfo()?.timezone ? 'Data/Hora' : 'Data/Hora (UTC)',
            Accessor: 'timestamp',
            sortable: false,
            filterable: false,
            Cell: (original) => {
                if (original?.timestamp) {
                    let dateFromUserTZ = moment.tz(original?.timestamp * 1000, 'UTC')
                    let formatted = dateFromUserTZ.tz(auth.getUserInfo()?.timezone ? auth.getUserInfo().timezone : 'UTC').format('DD/MM/YYYY HH:mm')
                    return (<div>{formatted}</div>)
                }
                else return ""
            }
        }, {
            Header: 'Status',
            Accessor: 'status',
            sortable: false,
            Cell: (original) => {
                return this.getStatusBadge(original?.status)
            },
        }, {
            Header: 'Interações',
            Accessor: 'interacoes',
            sortable: false,
            Cell: (original) => original?.interacoes?.length ?? 0,
        }, {
            Header: 'Automação',
            Accessor: 'automacao_id',
            sortable: false,
            Cell: (original) => {
                return <Link to={`/automacao/${original?.automacao_id}/editar`}>{original?.descricao}</Link>
            },
        }]
    }
    
    getStatusBadge = (status) => {
        const style = { fontSize: "9px", height: "14px", lineHeight: "9px", padding: "2px 4px" }
        const statusMap = {
            "new": <Badge style={style} color="primary">Novo</Badge>,
            "pending": <Badge style={style} color="warning">Pendente</Badge>,
            "finished": <Badge style={style} color="success">Finalizado</Badge>
        }
        return statusMap[status] || "---"
    }

    startAlertasInterval = () => {
        const { params } = this.state
        const intervaloMinutos = params.params?.intervalo

        if (intervaloMinutos && intervaloMinutos > 0) {
            const intervaloMs = intervaloMinutos * 60 * 1000
            
            if (this.state.alertasIntervalFn) {
                clearInterval(this.state.alertasIntervalFn)
            }

            const alertasIntervalFn = setInterval(() => {
                this.getAlertas({ clear: true })
            }, intervaloMs)

            this.setState({ alertasIntervalFn })
        }
    }

    restartAlertasInterval = () => {
        if (this.state.alertasIntervalFn) {
            clearInterval(this.state.alertasIntervalFn)
        }
        
        this.startAlertasInterval()
    }

    getAlertasSummary = () => {
        const { alertas } = this.state
        const total = alertas.length
        const novos = alertas.filter(alerta => alerta.status === 'new').length
        const pendentes = alertas.filter(alerta => alerta.status === 'pending').length
        const finalizados = alertas.filter(alerta => alerta.status === 'finished').length

        return { total, novos, pendentes, finalizados }
    }

    getStatusInfo = () => {
        const { alertas } = this.state
        
        if (alertas.length === 0) {
            return { status: 'Sem dados', isOutdated: false }
        }

        const ultimoAlerta = alertas.reduce((maisRecente, alerta) => {
            return (!maisRecente || alerta.timestamp > maisRecente.timestamp) ? alerta : maisRecente
        }, null)

        if (!ultimoAlerta || !ultimoAlerta.timestamp) {
            return { status: 'Sem dados', isOutdated: false }
        }

        const agora = new Date()
        const dataUltimoAlerta = new Date(ultimoAlerta.timestamp * 1000)
        const umMesAtras = new Date(agora.getTime() - (30 * 24 * 60 * 60 * 1000))

        const isOutdated = dataUltimoAlerta < umMesAtras
        const status = isOutdated ? 'Desatualizado' : 'Atualizado'

        return { status, isOutdated }
    }

    renderAlertasInfo = () => {
        const { count, count_novo, count_pendente, count_finalizados } = this.state 
        const { status, isOutdated } = this.getStatusInfo()
        
        return (
            <div className="hdv-top-bar-bloco">
                {this.props.editEnabled ?
                    <i className={this.props.shared ? "hdv-noshow-item" : "hdv-widget-options fa fa-ellipsis-v"}
                        onClick={(e) => {
                            this.props.onEditWidget && this.props.onEditWidget({
                                widget: {
                                    ...this.props.dataWidget,
                                    id: this.props.dataWidget.originalId || this.props.dataWidget.id
                                },
                                element: e.currentTarget.parentElement.querySelector(".hdv-top-bar-bloco span"),
                                input: this.props.dataWidget?.descricao || "Alertas"
                            })
                        }}
                    />
                    :
                    null
                }
                <i data-status={status} className="fa fa-square-full"></i>
                <span>Alertas</span>
                <div className="hdv-top-bar-hidden">
                    <p><b>Total de alertas:</b> {count}</p>
                    <p><b>Novos:</b> {count_novo} | <b>Pendentes:</b> {count_pendente} | <b>Finalizados:</b> {count_finalizados}</p>
                    <p><b>Status:</b> <span>{status}</span></p>
                    <p><i>Este resumo é gerado com base em todos os alertas atuais do sistema.</i></p>
                </div>
            </div>
        )
    }

    loadMoreScroll() {
        const el = document.querySelector(".box-simple-value");

        el.scrollBy({
            top: el.scrollHeight + 80,
            behavior: "smooth"
        });
    }

    render() {
        const { alertas, loading, selected } = this.state
        const hasEquipment = this.props.dataWidget?.equipamento

        return (
            <div className="hdv-bloco-informacao hdv-chart-bloco-reactgridlayout" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                {hasEquipment 
                    ? this.props.dataWidget?.ultimoEvento({ showUnity: false })
                    : this.renderAlertasInfo()
                }
                
                <ModalAlerta
                    show={selected != null}
                    alert={selected}
                    getData={this.getAlertas}
                    onClose={() => this.setState({ selected: null })}
                />

                <div className="box-simple-value" style={{ margin: '10px', flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', overflowX: 'hidden', overflowY: 'auto' }}>
                    <Table
                        notEditFirstColum={true}
                        columns={this.getColumns()}
                        search={false}
                        config={false}
                        data={alertas}
                        count={alertas.length}
                        loading={loading}
                        onUpdate={(table) => this.setState({ table })}
                        noFooter
                        disableRefreshButton={true}
                        hasLoadMore={true}
                        loadMoreScroll={this.loadMoreScroll}
                    />
                    <div className="report-table-pagination" style={{ padding: '5px 0', flexShrink: 0 }}>
                        <button
                            disabled={alertas.length === 0 || this.state.end}
                            onClick={this.carregarMais} 
                            style={{ cursor: "pointer", fontSize: '10px', padding: '3px 8px' }}>
                            Carregar Mais
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}

export default ListaAlertas
